<script setup>
    // Store
    import { useCommonStore } from '@/stores/common/commonStore';
    import { useMonthlyReportStore } from '@/stores/monthlyReport/MonthlyReportStore';

    // Vue
    import { computed, onMounted, reactive, ref, inject, nextTick } from 'vue';

    // Model
    import { MonrepcngRequest, MonrepcngisuRequest } from '@/models/monthlyReport/MonthlyReportModel';

    // library
    import Chart from 'chart.js/auto';

    // Utis
    import utils from '@/commonProject/helpers/utils';

    // メッセージダイアログ取得。
    const { messageDialog } = inject('messageDialogKey');

    // ----------------------------
    // 定数
    // ----------------------------
    const commonStore = useCommonStore();
    const monthlyReportStore = useMonthlyReportStore();
    const chartInstances = {};

    // ----------------------------
    // リアクティブ変数
    // ----------------------------
    const showContent = ref(false);
    const monthStart = ref('');
    const monthEnd = ref('');
    const organizationPk = ref('');
    const monrepcngRequest = reactive(new MonrepcngRequest());
    const monrepcngisuRequest = reactive(new MonrepcngisuRequest());
    const requestBody = reactive({
        MonthStart: monthStart.value,
        MonthEnd: monthEnd.value,
        OrganizationPk: organizationPk.value,
    });
    // 検索項目の表示制御
    const disabledControl = ref(false);
    // ローディング状態を管理
    const loading = ref(false);

    // ----------------------------
    // グラフ関数
    // ----------------------------
    function graph01(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.firstUserList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        const data = firstUserGraphData.value;
        let labels = firstUserData.value;
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: {
                labels: labels,
                datasets: [
                    {
                        xAxisID: 'xAxis',
                        yAxisID: 'yAxis',
                        data: data,
                        backgroundColor: '#5E9AD9', // バーの背景色
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    xAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                    yAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }
    function graph02(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.workerList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        const data = workerGraphData.value;
        let labels = workerData.value;
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: {
                labels: labels,
                datasets: [
                    {
                        xAxisID: 'xAxis',
                        yAxisID: 'yAxis',
                        data: data,
                        backgroundColor: '#5E9AD9', // バーの背景色
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    xAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                    yAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }
    function graph03(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.familyList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        const data = familyGraphData.value;
        let labels = familyData.value;
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: {
                labels: labels,
                datasets: [
                    {
                        xAxisID: 'xAxis',
                        yAxisID: 'yAxis',
                        data: data,
                        backgroundColor: '#5E9AD9', // バーの背景色
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                //indexAxis: 'y',
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    xAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                    yAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }
    function graph04(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.issueClassList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        const data = issueClassGraphData.value;
        let labels = issueClassData.value;
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: {
                labels: labels,
                datasets: [
                    {
                        xAxisID: 'xAxis',
                        yAxisID: 'yAxis',
                        data: data,
                        backgroundColor: '#5E9AD9', // バーの背景色
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    xAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                    yAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }
    function graph05(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.issueList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        const data = issueGraphData.value;
        let labels = issueData.value;
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: {
                labels: labels,
                datasets: [
                    {
                        xAxisID: 'xAxis',
                        yAxisID: 'yAxis',
                        data: data,
                        backgroundColor: '#5E9AD9', // バーの背景色
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    xAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                    yAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }

    function graph06(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.genderIssueList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: genderIssueGraphData.value,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y',
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        onClick: function () {
                            // Chart.jsの凡例をクリックしてグラフ部分の表示を切り替える機能を無効化する。
                            return false;
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: function (tooltipItem) {
                                const dataset = tooltipItem.dataset;
                                const index = tooltipItem.dataIndex;
                                const rowValue = dataset.rowData[index];

                                return `${dataset.label}: ${rowValue}`;
                            },
                        },
                    },
                },
                scales: {
                    yAxisTrgId: {
                        stacked: true,
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                        //max: 2080
                    },
                    xAxisTrgId: {
                        display: false,
                        stacked: true,
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }
    function graph07(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.referList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        const data = referGraphData.value;
        let labels = referData.value;
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: {
                labels: labels,
                datasets: [
                    {
                        xAxisID: 'xAxis',
                        yAxisID: 'yAxis',
                        data: data,
                        backgroundColor: '#5E9AD9', // バーの背景色
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    xAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                    yAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }
    // function graph08(trg) {
    //     destroyChart(trg);
    //     if (utils.isEmptyArray(monthlyReportStore.genderList)) {
    //         return;
    //     }
    //     const ctx = document.getElementById(trg).getContext('2d');
    //     const data = genderGraphData.value;
    //     let labels = genderData.value;
    //     chartInstances[trg] = new Chart(ctx, {
    //         type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
    //         data: {
    //             labels: labels,
    //             datasets: [
    //                 {
    //                     xAxisID: 'xAxis',
    //                     yAxisID: 'yAxis',
    //                     data: data,
    //                     backgroundColor: '#5E9AD9', // バーの背景色
    //                 },
    //             ],
    //         },
    //         options: {
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             plugins: {
    //                 legend: {
    //                     display: false,
    //                 },
    //                 tooltip: {
    //                     enabled: true,
    //                 },
    //             },
    //             scales: {
    //                 xAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //                 yAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //             },
    //         },
    //     });
    //     chartInstances[trg].update();
    // }
    // function graph09(trg) {
    //     destroyChart(trg);
    //     if (utils.isEmptyArray(monthlyReportStore.ageList)) {
    //         return;
    //     }
    //     const ctx = document.getElementById(trg).getContext('2d');
    //     const data = ageGraphData.value;
    //     let labels = ageData.value;
    //     chartInstances[trg] = new Chart(ctx, {
    //         type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
    //         data: {
    //             labels: labels,
    //             datasets: [
    //                 {
    //                     xAxisID: 'xAxis',
    //                     yAxisID: 'yAxis',
    //                     data: data,
    //                     backgroundColor: '#5E9AD9', // バーの背景色
    //                 },
    //             ],
    //         },
    //         options: {
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             plugins: {
    //                 legend: {
    //                     display: false,
    //                 },
    //                 tooltip: {
    //                     enabled: true,
    //                 },
    //             },
    //             scales: {
    //                 xAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //                 yAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //             },
    //         },
    //     });
    //     chartInstances[trg].update();
    // }
    function graph10(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.understandList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        const data = understandGraphData.value;
        let labels = understandData.value;
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: {
                labels: labels,
                datasets: [
                    {
                        xAxisID: 'xAxis',
                        yAxisID: 'yAxis',
                        data: data,
                        backgroundColor: '#5E9AD9', // バーの背景色
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    xAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                    yAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }
    function graph11(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.highStressList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        const data = highStressGraphData.value;
        let labels = highStressData.value;
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: {
                labels: labels,
                datasets: [
                    {
                        xAxisID: 'xAxis',
                        yAxisID: 'yAxis',
                        data: data,
                        backgroundColor: '#5E9AD9', // バーの背景色
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    xAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                    yAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }
    function graph12(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.issueHighStressList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        const data = issueHighStressGraphData.value;
        let labels = issueHighStressData.value;
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: {
                labels: labels,
                datasets: [
                    {
                        xAxisID: 'xAxis',
                        yAxisID: 'yAxis',
                        data: data,
                        backgroundColor: '#5E9AD9', // バーの背景色
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    xAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                    yAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }
    function graph13(trg) {
        destroyChart(trg);
        if (utils.isEmptyArray(monthlyReportStore.selfSignupList)) {
            return;
        }
        const ctx = document.getElementById(trg).getContext('2d');
        const data = selfSignupGraphData.value;
        let labels = selfSignupData.value;
        chartInstances[trg] = new Chart(ctx, {
            type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
            data: {
                labels: labels,
                datasets: [
                    {
                        xAxisID: 'xAxis',
                        yAxisID: 'yAxis',
                        data: data,
                        backgroundColor: '#5E9AD9', // バーの背景色
                    },
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    tooltip: {
                        enabled: true,
                    },
                },
                scales: {
                    xAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                    yAxis: {
                        min: 0,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            precision: 0,
                        },
                    },
                },
            },
        });
        chartInstances[trg].update();
    }
    // function graph14(trg) {
    //     destroyChart(trg);
    //     if (utils.isEmptyArray(monthlyReportStore.organizationList)) {
    //         return;
    //     }
    //     const ctx = document.getElementById(trg).getContext('2d');
    //     const data = organizationGraphData.value;
    //     let labels = organizationData.value;
    //     chartInstances[trg] = new Chart(ctx, {
    //         type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
    //         data: {
    //             labels: labels,
    //             datasets: [
    //                 {
    //                     xAxisID: 'xAxis',
    //                     yAxisID: 'yAxis',
    //                     data: data,
    //                     backgroundColor: '#5E9AD9', // バーの背景色
    //                 },
    //             ],
    //         },
    //         options: {
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             plugins: {
    //                 legend: {
    //                     display: false,
    //                 },
    //                 tooltip: {
    //                     enabled: true,
    //                 },
    //             },
    //             scales: {
    //                 xAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //                 yAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //             },
    //         },
    //     });
    //     chartInstances[trg].update();
    // }
    // function graph15(trg) {
    //     destroyChart(trg);
    //     if (utils.isEmptyArray(monthlyReportStore.positionList)) {
    //         return;
    //     }
    //     const ctx = document.getElementById(trg).getContext('2d');
    //     const data = positionGraphData.value;
    //     let labels = positionData.value;
    //     chartInstances[trg] = new Chart(ctx, {
    //         type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
    //         data: {
    //             labels: labels,
    //             datasets: [
    //                 {
    //                     xAxisID: 'xAxis',
    //                     yAxisID: 'yAxis',
    //                     data: data,
    //                     backgroundColor: '#5E9AD9', // バーの背景色
    //                 },
    //             ],
    //         },
    //         options: {
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             plugins: {
    //                 legend: {
    //                     display: false,
    //                 },
    //                 tooltip: {
    //                     enabled: true,
    //                 },
    //             },
    //             scales: {
    //                 xAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //                 yAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //             },
    //         },
    //     });
    //     chartInstances[trg].update();
    // }
    // function graph16(trg) {
    //     destroyChart(trg);
    //     if (utils.isEmptyArray(monthlyReportStore.issueClassList)) {
    //         return;
    //     }
    //     const ctx = document.getElementById(trg).getContext('2d');
    //     const data = serviceLengthGraphData.value;
    //     let labels = serviceLengthData.value;
    //     chartInstances[trg] = new Chart(ctx, {
    //         type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
    //         data: {
    //             labels: labels,
    //             datasets: [
    //                 {
    //                     xAxisID: 'xAxis',
    //                     yAxisID: 'yAxis',
    //                     data: data,
    //                     backgroundColor: '#5E9AD9', // バーの背景色
    //                 },
    //             ],
    //         },
    //         options: {
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             plugins: {
    //                 legend: {
    //                     display: false,
    //                 },
    //                 tooltip: {
    //                     enabled: true,
    //                 },
    //             },
    //             scales: {
    //                 xAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //                 yAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //             },
    //         },
    //     });
    //     chartInstances[trg].update();
    // }
    // function graph17(trg) {
    //     destroyChart(trg);
    //     if (utils.isEmptyArray(monthlyReportStore.jobCategoryList)) {
    //         return;
    //     }
    //     const ctx = document.getElementById(trg).getContext('2d');
    //     const data = jobCategoryGraphData.value;
    //     let labels = jobCategoryData.value;
    //     chartInstances[trg] = new Chart(ctx, {
    //         type: 'bar', // チャートの種類を指定します (bar, line, pieなど)
    //         data: {
    //             labels: labels,
    //             datasets: [
    //                 {
    //                     xAxisID: 'xAxis',
    //                     yAxisID: 'yAxis',
    //                     data: data,
    //                     backgroundColor: '#5E9AD9', // バーの背景色
    //                 },
    //             ],
    //         },
    //         options: {
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             plugins: {
    //                 legend: {
    //                     display: false,
    //                 },
    //                 tooltip: {
    //                     enabled: true,
    //                 },
    //             },
    //             scales: {
    //                 xAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //                 yAxis: {
    //                     min: 0,
    //                     grid: {
    //                         display: false,
    //                     },
    //                 },
    //             },
    //         },
    //     });
    //     chartInstances[trg].update();
    // }

    // ----------------------------
    // 関数
    // ----------------------------
    // 表示押下時
    async function onDisplay() {
        // 初期化する。
        showContent.value = false;
        reset();
        monthlyReportStore.reset();
        // 検索項目の表示制御
        disabledControl.value = true;
        // ローディングアニメーションを表示
        loading.value = true;

        // 月次レポート表示可否確認APIのリクエストボディを生成する。
        let requestBodyForMonthlyReportCheck = {};

        // 月次レポートの各表示条件をリクエストボディに設定する。

        // 月次レポートの表示範囲開始日が設定されているか判定する。
        if (!utils.isNullEmpty(monthStart.value)) {
            requestBodyForMonthlyReportCheck['MonthStart'] = monthStart.value;
        }

        // 月次レポートの表示範囲終了日が設定されているか判定する。
        if (!utils.isNullEmpty(monthEnd.value)) {
            requestBodyForMonthlyReportCheck['MonthEnd'] = monthEnd.value;
        }

        // 月次レポートの表示対象組織が選択されているか判定する。
        if (!utils.isNullEmpty(organizationPk.value)) {
            requestBodyForMonthlyReportCheck['OrganizationPk'] = organizationPk.value;
        }

        // 月次レポート表示可否確認APIのリクエストボディをコールする。
        const responseBodyForMonthlyReportCheck = await monthlyReportStore.getMonthlyReportCheckAction(commonStore.API_URL, requestBodyForMonthlyReportCheck);

        // 月次レポート表示可否確認APIが正常応答か判定する。
        if (responseBodyForMonthlyReportCheck.success) {
            // 月次レポートを表示可能かどうか判定する。
            if (responseBodyForMonthlyReportCheck.responseBody.ApiRes.Status === 0) {
                // ステータスが0の場合は月次レポートは表示可能。

                // 月次レポート（利用実績）
                monrepcngRequest.MonthStart = monthStart.value;
                monrepcngRequest.MonthEnd = monthEnd.value;
                monrepcngRequest.OrganizationPk = organizationPk.value;
                // 月次レポート（利用実績イシュー別）
                monrepcngisuRequest.MonthStart = monthStart.value;
                monrepcngisuRequest.MonthEnd = monthEnd.value;
                monrepcngisuRequest.OrganizationPk = organizationPk.value;
                // 月次レポート（その他）
                requestBody.MonthStart = monthStart.value;
                requestBody.MonthEnd = monthEnd.value;
                requestBody.OrganizationPk = organizationPk.value;

                // 月次レポート（利用者）API
                // 01. 登録従業員の内訳（性別）
                // 月次レポート（利用者）APIのリクエストボディを生成する。
                const requestBody1 = {
                    OrganizationPk: organizationPk.value,
                };
                // // 月次レポート（利用者）APIをコールする。
                const response1 = await monthlyReportStore.getMonthlyReportCliantAction(commonStore.API_URL, requestBody1);
                if (!response1.success) {
                    messageDialog('error', response1.errorMessage);
                    if (response1.redirect) {
                        location.href = response1.redirectUrl;
                    }
                }
                // 月次レポート（利用実績）「利用件数（相談方法）（従業員）」
                // 03. 相談方法別利用件数（従業員） 件数の初期選択時
                // 条件に限定したリクエストボディを生成する。
                const requestBody3 = {
                    MonthStart: monthStart.value,
                    MonthEnd: monthEnd.value,
                    OrganizationPk: organizationPk.value,
                    Cond: {
                        ClientType: '1', // 種別：従業員
                    },
                    Unit: '1', // 件数単位
                };
                const response3 = await monthlyReportStore.getMonthlyReportConfigAction(commonStore.API_URL, requestBody3, 'worker');
                if (!response3.success) {
                    messageDialog('error', response3.errorMessage);
                    if (response3.redirect) {
                        location.href = response3.redirectUrl;
                    }
                }
                // 月次レポート（利用実績）「利用件数（相談方法）（家族）」
                // 04. 相談方法別利用件数（家族）
                // 条件に限定したリクエストボディを生成する。
                const requestBody4 = {
                    MonthStart: monthStart.value,
                    MonthEnd: monthEnd.value,
                    OrganizationPk: organizationPk.value,
                    Cond: {
                        ClientType: '2', // 種別：家族
                    },
                    Unit: '1', // 件数単位
                };
                const response4 = await monthlyReportStore.getMonthlyReportConfigAction(commonStore.API_URL, requestBody4, 'family');
                if (!response4.success) {
                    messageDialog('error', response4.errorMessage);
                    if (response4.redirect) {
                        location.href = response4.redirectUrl;
                    }
                }
                // 月次レポート（利用実績イシュー分類別）「利用実績イシュー分類別」
                // 05. 相談内容分類別利用件数
                const response5 = await monthlyReportStore.getMonthlyReportIssueClassAction(commonStore.API_URL, requestBody);
                if (!response5.success) {
                    messageDialog('error', response5.errorMessage);
                    if (response5.redirect) {
                        location.href = response5.redirectUrl;
                    }
                }
                // 月次レポート（利用実績イシュー別）「利用件数（相談内容）」
                // 06. 相談内容別利用件数
                // 条件に限定したリクエストボディを生成する。
                const requestBody6 = {
                    MonthStart: monthStart.value,
                    MonthEnd: monthEnd.value,
                    OrganizationPk: organizationPk.value,
                    Unit: '1', // 件数単位
                };
                const response6 = await monthlyReportStore.getMonthlyReportIssueAction(commonStore.API_URL, requestBody6, 'issue');
                if (!response6.success) {
                    messageDialog('error', response6.errorMessage);
                    if (response6.redirect) {
                        location.href = response6.redirectUrl;
                    }
                }
                // 月次レポート（リファー先）「専門機関への紹介件数」
                // 12. 専門機関への紹介件数
                const response8 = await monthlyReportStore.getMonthlyReportReferAction(commonStore.API_URL, requestBody);
                if (!response8.success) {
                    messageDialog('error', response8.errorMessage);
                    if (response8.redirect) {
                        location.href = response8.redirectUrl;
                    }
                }
                // 月次レポート（利用実績）「性別利用人数」
                // 10. 性別相談利用人数
                // 条件に限定したリクエストボディを生成する。
                const requestBody9 = {
                    MonthStart: monthStart.value,
                    MonthEnd: monthEnd.value,
                    OrganizationPk: organizationPk.value,
                    GroupingType: '1', // グルーピング種別：性別
                    Unit: '2', // 人数単位
                };
                const response9 = await monthlyReportStore.getMonthlyReportUseAction(commonStore.API_URL, requestBody9, 'gender');
                if (!response9.success) {
                    messageDialog('error', response9.errorMessage);
                    if (response9.redirect) {
                        location.href = response9.redirectUrl;
                    }
                }
                // 月次レポート（現況把握回答）「現状把握内容別回答人数」
                // 07. 現況把握内容別回答人数
                // 条件に限定したリクエストボディを生成する。
                let requestBody11 = {};
                if (!utils.isNullEmpty(monthStart.value)) {
                    requestBody11['MonthStart'] = monthStart.value;
                }
                if (!utils.isNullEmpty(monthEnd.value)) {
                    requestBody11['MonthEnd'] = monthEnd.value;
                }
                if (!utils.isNullEmpty(organizationPk.value)) {
                    requestBody11['OrganizationPk'] = organizationPk.value;
                }
                const response11 = await monthlyReportStore.getMonthlyReportUnderstandAction(commonStore.API_URL, requestBody11);
                if (!response11.success) {
                    messageDialog('error', response11.errorMessage);
                    if (response11.redirect) {
                        location.href = response11.redirectUrl;
                    }
                }
                // 月次レポート（利用実績）「高ストレス者件数」
                // 08. 高ストレス者・要注意者利用件数 件数の初期選択時
                // 条件に限定したリクエストボディを生成する。
                const requestBody12 = {
                    MonthStart: monthStart.value,
                    MonthEnd: monthEnd.value,
                    OrganizationPk: organizationPk.value,
                    Cond: {
                        HighStress: true, // 高ストレス
                        ClientType: '1', // 種別：従業員
                    },
                    Unit: '1', // 件数単位
                };
                const response12 = await monthlyReportStore.getMonthlyReportConfigAction(commonStore.API_URL, requestBody12, 'highStress');
                if (!response12.success) {
                    messageDialog('error', response12.errorMessage);
                    if (response12.redirect) {
                        location.href = response12.redirectUrl;
                    }
                }
                // 月次レポート（利用実績イシュー別）「高ストレス者利用件数（相談内容）」
                // 09. 高ストレス者ｘ相談内容別利用件数 件数の初期選択時
                // 条件に限定したリクエストボディを生成する。
                const requestBody13 = {
                    MonthStart: monthStart.value,
                    MonthEnd: monthEnd.value,
                    OrganizationPk: organizationPk.value,
                    Cond: {
                        HighStress: true, // 高ストレス
                    },
                    Unit: '1', // 件数単位
                };
                const response13 = await monthlyReportStore.getMonthlyReportIssueAction(commonStore.API_URL, requestBody13, 'issueHighStress');
                if (!response13.success) {
                    messageDialog('error', response13.errorMessage);
                    if (response13.redirect) {
                        location.href = response13.redirectUrl;
                    }
                }
                // 月次レポート（利用実績）「自由登録型ユーザー利用件数」
                // 02. 自由登録型従業員利用件数 件数の初期選択時
                // 条件に限定したリクエストボディを生成する。
                const requestBody14 = {
                    MonthStart: monthStart.value,
                    MonthEnd: monthEnd.value,
                    OrganizationPk: organizationPk.value,
                    Cond: {
                        SelfSignup: true, // 自己登録
                        ClientType: '1', // 種別：従業員
                    },
                    Unit: '1', // 件数単位
                };
                const response14 = await monthlyReportStore.getMonthlyReportConfigAction(commonStore.API_URL, requestBody14, 'selfSignup');
                if (!response14.success) {
                    messageDialog('error', response14.errorMessage);
                    if (response14.redirect) {
                        location.href = response14.redirectUrl;
                    }
                }
                // 月次レポート（アンケート回答）「アンケート満足度」
                // 13. 相談満足度
                const response15 = await monthlyReportStore.getMonthlyReportQuestionAction(commonStore.API_URL, requestBody);
                if (!response15.success) {
                    messageDialog('error', response15.errorMessage);
                    if (response15.redirect) {
                        location.href = response15.redirectUrl;
                    }
                }
                // 月次レポート（利用実績）「組織別利用人数」
                // 11. 組織別相談利用人数
                // 条件に限定したリクエストボディを生成する。
                const requestBody16 = {
                    MonthStart: monthStart.value,
                    MonthEnd: monthEnd.value,
                    OrganizationPk: organizationPk.value,
                    GroupingType: '4', // グルーピング種別：組織
                    Unit: '2', // 人数単位
                };
                const response16 = await monthlyReportStore.getMonthlyReportUseAction(commonStore.API_URL, requestBody16, 'organization');
                if (!response16.success) {
                    messageDialog('error', response16.errorMessage);
                    if (response16.redirect) {
                        location.href = response16.redirectUrl;
                    }
                }

                showContent.value = true;
                await nextTick(); // DOMの更新を待つ

                graph01('graph01');
                graph02('graph02');
                graph03('graph03');
                graph04('graph04');
                graph05('graph05');
                graph06('graph06');
                graph07('graph07');
                // graph08('graph08');
                // graph09('graph09');
                graph10('graph10');
                graph11('graph11');
                graph12('graph12');
                graph13('graph13');
                // graph14('graph14');
                // graph15('graph15');
                // graph16('graph16');
                // graph17('graph17');
            } else {
                // ステータスが0以外の場合は月次レポートは表示不可能。
                // APIのエラーメッセージを表示する。

                // ローディングアニメーションを非表示
                loading.value = false;
                messageDialog('error', responseBodyForMonthlyReportCheck.responseBody.ApiRes.MessageJp);
            }
        } else {
            // ローディングアニメーションを非表示
            loading.value = false;
            messageDialog('error', responseBodyForMonthlyReportCheck.errorMessage);
            if (responseBodyForMonthlyReportCheck.redirect) {
                location.href = responseBodyForMonthlyReportCheck.redirectUrl;
            }
        }
        // ローディングアニメーションを非表示
        loading.value = false;
        // 検索項目の表示制御
        disabledControl.value = false;
    }

    /**
     * 共通処理
     */
    // データが存在するか判定
    function hasData(data) {
        return Array.isArray(data) && data.length > 0;
    }

    // 月データを取得
    function extractMonths(data, key = 'Month') {
        if (!Array.isArray(data)) return [];
        return data.map((item) => item[key]).filter((month) => month);
    }

    // 指定された月のVolAllの値を取得
    function getVolAll(month, key) {
        const monthData = key.find((item) => item.Month === month);
        if (monthData && monthData.VolAll === -1) {
            return '-';
        }
        return monthData && monthData.VolAll !== null ? monthData.VolAll : 0;
    }

    // 指定した項目の合計を計算
    function calculateTotal(data, field) {
        if (!hasData(data)) return 0;
        if (field === 'VolAll') {
            // -1が含まれている場合'-'を返す
            if (data.some(item => item[field] === -1)) return '-';
            // -1が含まれていなければ合計を返す
            return data.reduce((sum, item) => sum + (item[field] || 0), 0);
        }
        return data.reduce((sum, item) => sum + (item[field] || 0), 0);
    }

    // 指定した名前の月別の値を取得
    function getMonthlyVol(item, month) {
        const monthData = item.Months.find((item) => item.Month === month);
        if (monthData) {
            if (monthData.Volume === -1) {
                return '-';
            }
            return monthData.Volume !== null ? monthData.Volume : 0;
        }
        return 0;
    }

    // 各キーの合計を取得
    function getRowAll(data) {
        return data.Months.reduce((sum, entry) => sum + (entry.Volume ?? 0), 0);
    }

    // 各月ごとの合計を計算
    function getColumnAll(data, month) {
        for (const obj of data) {
            for ( const obj2 of obj.Months) {
                if (obj2.Month === month) {
                    if (obj2.Volume === -1) {
                        return '-';
                    }
                }
            }
        }
        return data.reduce((sum, data) => sum + getMonthlyVol(data, month), 0);
    }

    // 指定した名前の月別の値を取得(Volume)
    function getMonthlyVolume(item, month) {
        const monthData = item.Months.find((item) => item.Month === month);
        return monthData && monthData.Volume !== -1 ? monthData.Volume : '-';
    }

    // 各キーの合計を取得(Volume)
    function getRowVolume(data) {
        const volumes = data.Months.map((e) => (e.Volume === -1 ? '-' : e.Volume ?? 0));
        // 1つでも '-'が含まれている場合
        if (volumes.includes('-')) {
            return '-';
        }
        return volumes.reduce((sum, entry) => sum + entry, 0);
    }

    // 各月ごとの合計を計算(Volume)
    function getColumnVolume(data, month) {
        let result = 0;
        let foundMinus = false;

        for (let item of data) {
            const value = getMonthlyVolume(item, month);
            if (value === '-') {
                foundMinus = true;
                break;
            } else {
                result += value;
            }
        }
        return foundMinus ? '-' : result;
    }

    /**
     * 01. 登録従業員の関数 [従業員数性別]
     */
    // 性別毎のVolumeをオブジェクトマッピング
    const volumes = computed(() => {
        if (monthlyReportStore.userList.length > 0) {
            return monthlyReportStore.userList.reduce((acc, item) => {
                const key = item.Gender === null ? 'null' : item.Gender;
                acc[key] = item.Volume;
                return acc;
            }, {});
        }
        return {};
    });
    // 合計の計算
    const totalVolume = computed(() => calculateTotal(monthlyReportStore.userList, 'Volume'));

    // 各性別の割合を計算
    const percentages = computed(() => {
        const total = totalVolume.value;
        if (monthlyReportStore.userList.length > 0) {
            return monthlyReportStore.userList.reduce((acc, item) => {
                const key = item.Gender === null ? 'null' : item.Gender;
                acc[key] = ((item.Volume / total) * 100).toFixed(1);
                return acc;
            }, {});
        }
        return {};
    });

    // 表示形式を「vol(割合%)」にフォーマット変換
    function formatPercentage(key) {
        const volume = volumes.value[key] || 0;
        const percentage = percentages.value[key] || 0;
        return `${volume} (${percentage}%)`;
    }

    /**
     * 02. 自由登録型従業員利用件数
     */
    // 月データを取得
    const selfSignupData = computed(() => (monthlyReportStore.selfSignupList.length > 0 ? extractMonths(monthlyReportStore.selfSignupList) : []));

    // 「自由登録型ユーザー」全体の合計を取得
    const selfSignupAll = computed(() => (monthlyReportStore.selfSignupList.length > 0 ? calculateTotal(monthlyReportStore.selfSignupList, 'VolAll') : 0));

    // 「自由登録型ユーザー」グラフデータ
    const selfSignupGraphData = computed(() => {
        if (monthlyReportStore.selfSignupList.length > 0) {
            return monthlyReportStore.selfSignupList.map((item) => item.VolAll ?? 0);
        }
        return [];
    });

    /**
     * （顧客非表示） 初回利用人数 [サービス初回利用人数]
     */
    // 月データを取得
    const firstUserData = computed(() => (monthlyReportStore.firstUserList.length > 0 ? extractMonths(monthlyReportStore.firstUserList) : []));

    // 指定された月のVolIniの値を取得
    // function getVolIni(month, key) {
    //     const monthData = key.find((item) => item.Month === month);
    //     return monthData && monthData.VolIni !== null ? monthData.VolIni : 0;
    // }

    // 「初回利用人数」全体の合計を取得
    // const firstUserAll = computed(() => {
    //     if (monthlyReportStore.firstUserList.length > 0) {
    //         return monthlyReportStore.firstUserList.reduce((sum, entry) => sum + (entry.VolIni ?? 0), 0);
    //     }
    //     return 0;
    // });

    // 「初回利用人数」グラフデータ
    const firstUserGraphData = computed(() => {
        if (monthlyReportStore.firstUserList.length > 0) {
            return monthlyReportStore.firstUserList.map((item) => item.VolIni ?? 0);
        }
        return [];
    });

    /**
     * 03. 相談方法別利用件数（従業員） [利用件数/人数（相談方法）（従業員）]
     */
    // 月データを取得
    const workerData = computed(() => (monthlyReportStore.workerList.length > 0 ? extractMonths(monthlyReportStore.workerList) : []));

    // VolIni, VolAll以外の各キーを取得
    const otherKeys = computed(() => {
        const keys = new Set();
        if (monthlyReportStore.workerList.length > 0) {
            monthlyReportStore.workerList.forEach((item) => {
                Object.keys(item).forEach((key) => {
                    if (key !== 'Month' && key !== 'VolAll' && key !== 'VolIni') {
                        keys.add(key);
                    }
                });
            });
            return Array.from(keys);
        }
        return [];
    });

    // 指定された月と項目に対応する値を取得
    function getOther(month, key) {
        if (monthlyReportStore.workerList.length > 0) {
            const monthData = monthlyReportStore.workerList.find((item) => item.Month === month);
            return monthData && monthData[key] !== null ? monthData[key] : 0;
        }
    }

    // 「相談方法別利用件数（従業員）」各キーの合計を取得
    function workerAll(key) {
        if (monthlyReportStore.workerList.length > 0) {
            return monthlyReportStore.workerList.reduce((sum, entry) => sum + (entry[key] ?? 0), 0);
        }
    }

    // 「相談方法別利用件数（従業員）」各月の合計を取得
    function getMonthlyAll(month) {
        if (monthlyReportStore.workerList.length > 0) {
            return otherKeys.value.reduce((sum, key) => sum + getOther(month, key), 0);
        }
    }

    // 「相談方法別利用件数（従業員）」全体の合計を取得
    const workerTotal = computed(() => {
        if (monthlyReportStore.workerList.length > 0) {
            return workerData.value.reduce((sum, month) => sum + getMonthlyAll(month), 0);
        }
        return 0;
    });

    // 「相談方法別利用件数（従業員）」グラフデータ
    const workerGraphData = computed(() => {
        if (monthlyReportStore.workerList.length > 0) {
            return workerData.value.map((month) => {
                return otherKeys.value.reduce((sum, key) => {
                    const item = monthlyReportStore.workerList.find((entry) => entry.Month === month);
                    return sum + (item && item[key] != null ? item[key] : 0);
                }, 0);
            });
        }
        return [];
    });

    /**
     * 04. 相談方法別利用件数（家族） [利用件数/人数（相談方法）（家族）]
     */
    // 月データを取得
    const familyData = computed(() => (monthlyReportStore.familyList.length > 0 ? extractMonths(monthlyReportStore.familyList) : []));

    // VolIni, VolAll以外の各キーを取得
    const otherKeysFamily = computed(() => {
        const keys = new Set();
        if (monthlyReportStore.familyList.length > 0) {
            monthlyReportStore.familyList.forEach((item) => {
                Object.keys(item).forEach((key) => {
                    if (key !== 'Month' && key !== 'VolAll' && key !== 'VolIni') {
                        keys.add(key);
                    }
                });
            });
            return Array.from(keys);
        }
        return [];
    });

    // 指定された月と項目に対応する値を取得
    function getOtherFamily(month, key) {
        if (monthlyReportStore.familyList.length > 0) {
            const monthData = monthlyReportStore.familyList.find((item) => item.Month === month);
            return monthData && monthData[key] !== null ? monthData[key] : 0;
        }
    }

    // [利用件数/人数（相談方法）（家族）]各キーの合計を取得
    function familyAll(key) {
        if (monthlyReportStore.familyList.length > 0) {
            return monthlyReportStore.familyList.reduce((sum, entry) => sum + (entry[key] ?? 0), 0);
        }
    }

    // [利用件数/人数（相談方法）（家族）]各月の合計を取得
    function getMonthlyFamilyAll(month) {
        if (monthlyReportStore.familyList.length > 0) {
            return otherKeysFamily.value.reduce((sum, key) => sum + getOtherFamily(month, key), 0);
        }
    }

    // [利用件数/人数（相談方法）（家族）]全体の合計を取得
    const familyTotal = computed(() => {
        if (monthlyReportStore.familyList.length > 0) {
            return familyData.value.reduce((sum, month) => sum + getMonthlyFamilyAll(month), 0);
        }
        return 0;
    });

    // [利用件数/人数（相談方法）（家族）]グラフデータ
    const familyGraphData = computed(() => {
        if (monthlyReportStore.familyList.length > 0) {
            return familyData.value.map((month) => {
                return otherKeysFamily.value.reduce((sum, key) => {
                    const item = monthlyReportStore.familyList.find((entry) => entry.Month === month);
                    return sum + (item && item[key] != null ? item[key] : 0);
                }, 0);
            });
        }
        return [];
    });

    /**
     * 05. 相談内容分類別利用件数 [利用件数（相談内容分類）]
     */
    // 月データを取得
    const issueClassData = computed(() => {
        const monthSet = new Set();
        if (monthlyReportStore.issueClassList.length > 0) {
            monthlyReportStore.issueClassList.forEach((item) => {
                item.Months.forEach((entry) => {
                    monthSet.add(entry.Month);
                });
            });
        }
        return Array.from(monthSet);
    });

    // 「利用件数（相談内容分類）」全体の合計を取得
    const issueClassTotal = computed(() => {
        if (monthlyReportStore.issueClassList.length > 0) {
            return issueClassData.value.reduce((sum, month) => sum + getColumnAll(monthlyReportStore.issueClassList, month), 0);
        }
        return 0;
    });

    // 「利用件数（相談内容分類）」グラフデータ
    const issueClassGraphData = computed(() => {
        if (monthlyReportStore.issueClassList.length > 0) {
            return issueClassData.value.map((month) => getColumnAll(monthlyReportStore.issueClassList, month));
        }
        return 0;
    });

    /**
     * 06. 相談内容別利用件数 [利用件数（相談内容）]
     */
    // 月データを取得
    const issueData = computed(() => {
        const monthSet = new Set();
        if (monthlyReportStore.issueList.length > 0) {
            monthlyReportStore.issueList.forEach((item) => {
                item.Months.forEach((entry) => {
                    monthSet.add(entry.Month);
                });
            });
        }
        return Array.from(monthSet);
    });

    // 「利用件数（相談内容分類）」全体の合計を取得
    const issueTotal = computed(() => {
        if (monthlyReportStore.issueList.length > 0) {
            return issueData.value.reduce((sum, month) => sum + getColumnAll(monthlyReportStore.issueList, month), 0);
        }
        return 0;
    });

    // 「利用件数（相談内容分類）」グラフデータ
    const issueGraphData = computed(() => {
        if (monthlyReportStore.issueList.length > 0) {
            return issueData.value.map((month) => getColumnAll(monthlyReportStore.issueList, month));
        }
        return [];
    });

    /**
     * （顧客非表示） 性別ｘ相談内容別利用件数 [利用件数（性別×相談内容）]
     */
    // 月データを取得
    const genderIssueData = computed(() => {
        const monthSet = new Set();
        if (monthlyReportStore.genderIssueList.length > 0) {
            monthlyReportStore.genderIssueList.forEach((item) => {
                item.Months.forEach((entry) => {
                    monthSet.add(entry.Month);
                });
            });
        }
        return Array.from(monthSet);
    });

    // 性別ごとにデータをグルーピング、その合計を計算
    const groupedData = computed(() => {
        const result = {};

        monthlyReportStore.genderIssueList.forEach((item) => {
            const gender = item.GrpGender;
            if (!result[gender]) result[gender] = [];

            // 各データの月毎の情報を整備
            const monthsData = {};
            let total = 0;

            genderIssueData.value.forEach((month) => {
                const monthData = item.Months.find((m) => m.Month === month);
                const volume = monthData ? monthData.Volume === -1 ? '-' : monthData.Volume : 0;
                monthsData[month] = volume;
                if (volume === '-' || total === '-') {
                    total = '-';
                } else {
                    total += volume;
                }
            });

            result[gender].push({
                ...item,
                gender,
                months: monthsData,
                total,
            });
        });
        return result;
    });

    //「利用件数（性別×相談内容）」グラフデータ
    const genderIssueGraphData = computed(() => {
        const labels = [];
        const datasets = [];
        // 21まで対応可能
        const backgroundColors = ['#5E9AD9', '#84B8EC', '#B1D0EC', '#D96DB4', '#EF95CF', '#ECC0DD', '#89BF54', '#A8D17F', '#C8DEB2', '#C4B256', '#DECB6A', '#E5DBA9', '#A172D1', '#C0A4DB', '#D9C9E9', '#D88867', '#E9A283', '#ECC8B9', '#3BB8BB', '#61CFCF', '#BDDFDF'];
        const totalByGender = {};
        const uniqueLabels = new Set();

        // 各性別毎の合計を計算
        Object.entries(groupedData.value).forEach(([gender, items]) => {
            const genderLabel = commonStore.getConvertDictionary('GrpGender', gender);
            if (!labels.includes(genderLabel)) {
                labels.push(genderLabel);
            }
            if (items.includes('-')) {
                totalByGender[genderLabel] = '-';
            } else {
                totalByGender[genderLabel] = items.reduce((sum, item) => sum + (item.total || 0), 0);
            }
            
            // 各性別毎のラベルを収集
            items.forEach((item) => {
                //APIから取得したイシューPK、イシュー名に応じて画面に表示するラベルを制御
                //ラベルを初期化
                let issueLabel = '';
                //イシューPKをnullまたは-1で判定
                if (utils.isNullEmpty(item.IssuePk) || item.IssuePk === '-1') {
                    //イシューPKがnullまたは-1の場合、APIで集計時に集計できなかった例外扱いのため、画面表示のラベルは「不明」とする
                    issueLabel = '不明';
                } else {
                    //else:nullまたは-1ではない場合

                    // #イシュー名がnullや空の場合、画面表示のラベルは「」空とする
                    // #イシュー名がnullや空ではない場合、APIから取得したイシュー名をラベルに設定する
                    issueLabel = utils.isNullEmpty(item.IssueNm) ? '' : item.IssueNm;
                }
                //画面表示のための変数に格納
                uniqueLabels.add(issueLabel);
            });
        });

        const issueLabels = Array.from(uniqueLabels);

        // 各性別毎にデータをセット
        Object.entries(groupedData.value).forEach(([gender, items]) => {
            if (!labels.includes(commonStore.getConvertDictionary('GrpGender', gender))) {
                labels.push(commonStore.getConvertDictionary('GrpGender', gender));
            }
            items.forEach((item) => {
                // 不明が既に含まれていて、不明に該当するもの（IssueNmがnull, IssuePkがnullまたは-1）があった場合datasetしない判定
                let dataset = datasets.find((ds) => ds.label === item.IssueNm || (ds.label === '不明' && utils.isNullEmpty(item.IssueNm) && (utils.isNullEmpty(item.IssuePk) || item.IssuePk === '-1')) || item.total === '-');

                //APIから取得したイシューPK、イシュー名に応じて画面に表示するラベルを制御
                //ラベルを初期化
                let issueLabel = '';
                //イシューPKをnullまたは-1で判定
                if (utils.isNullEmpty(item.IssuePk) || item.IssuePk === '-1') {
                    //イシューPKがnullまたは-1の場合、APIで集計時に集計できなかった例外扱いのため、画面表示のラベルは「不明」とする
                    issueLabel = '不明';
                } else {
                    //else:nullまたは-1ではない場合

                    // #イシュー名がnullや空の場合、画面表示のラベルは「」空とする
                    // #イシュー名がnullや空ではない場合、APIから取得したイシュー名をラベルに設定する
                    issueLabel = utils.isNullEmpty(item.IssueNm) ? '' : item.IssueNm;
                }

                if (!dataset) {
                    dataset = {
                        label: issueLabel,
                        data: Array(labels.length).fill(0),
                        rowData: Array(labels.length).fill(0),
                        xAxisID: 'xAxisTrgId',
                        yAxisID: 'yAxisTrgId',
                        backgroundColor: backgroundColors[issueLabels.indexOf(issueLabel) % backgroundColors.length], // バーの背景色
                    };
                    if (item.total !== '-')
                    datasets.push(dataset);
                }
                // 各性別の位置にデータを追加
                const genderLabel = commonStore.getConvertDictionary('GrpGender', gender);
                const getIndex = labels.indexOf(genderLabel);
                dataset.data[getIndex] = totalByGender[genderLabel] !== '-' ? totalByGender[genderLabel] > 0 ? ((item.total || 0) / totalByGender[genderLabel]) * 100 :'-': 0;
                dataset.rowData[getIndex] = item.total || 0;
            });
        });

        return {
            labels,
            datasets,
        };
    });

    /**
     * 07. 現況把握内容別回答人数 [現況把握内容別回答人数]
     */
    // 月データを取得
    const understandData = computed(() => {
        const monthSet = new Set();
        if (monthlyReportStore.understandList.length > 0) {
            monthlyReportStore.understandList.forEach((item) => {
                item.Months.forEach((entry) => {
                    monthSet.add(entry.Month);
                });
            });
        }
        return Array.from(monthSet);
    });

    // [現況把握内容別回答人数] 全体の合計を取得
    const understandTotal = computed(() => {
        if (monthlyReportStore.understandList.length > 0) {
            return understandData.value.reduce((sum, month) => sum + getColumnAll(monthlyReportStore.understandList, month), 0);
        }
        return 0;
    });

    // [現況把握内容別回答人数] グラフデータ
    const understandGraphData = computed(() => {
        if (monthlyReportStore.understandList.length > 0) {
            return understandData.value.map((month) => getColumnAll(monthlyReportStore.understandList, month));
        }
        return [];
    });

    /**
     * 08. 高ストレス者・要注意者利用件数 [高ストレス者利用件数]
     */
    // 月データを取得
    const highStressData = computed(() => (monthlyReportStore.highStressList.length > 0 ? extractMonths(monthlyReportStore.highStressList) : []));

    // [高ストレス者利用件数]全体の合計を取得
    const highStressAll = computed(() => (monthlyReportStore.highStressList.length > 0 ? calculateTotal(monthlyReportStore.highStressList, 'VolAll') : 0));

    // [高ストレス者利用件数]グラフデータ
    const highStressGraphData = computed(() => {
        if (monthlyReportStore.highStressList.length > 0) {
            return monthlyReportStore.highStressList.map((item) => item.VolAll ?? 0);
        }
        return 0;
    });

    /**
     * 09. 高ストレス者ｘ相談内容別利用件数 [高ストレス者利用件数（相談内容）]
     */
    // 月データを取得
    const issueHighStressData = computed(() => {
        const monthSet = new Set();
        if (monthlyReportStore.issueHighStressList.length > 0) {
            monthlyReportStore.issueHighStressList.forEach((item) => {
                item.Months.forEach((entry) => {
                    monthSet.add(entry.Month);
                });
            });
        }
        return Array.from(monthSet);
    });

    // 「利用件数（相談内容分類）」全体の合計を取得
    const issueHighStressTotal = computed(() => {
        let flag = false;
        if (monthlyReportStore.issueHighStressList.length > 0) {
            return issueHighStressData.value.reduce((sum, month) => {
                const result = getColumnVolume(monthlyReportStore.issueHighStressList, month);
                if (result === '-') {
                    flag = true;
                }
                if (!flag) {
                    return (sum += result);
                } else {
                    return '-';
                }
            }, 0);
        }
        return 0;
    });

    // 「利用件数（相談内容分類）」グラフデータ
    const issueHighStressGraphData = computed(() => {
        if (monthlyReportStore.issueHighStressList.length > 0) {
            return issueHighStressData.value.map((month) => getColumnAll(monthlyReportStore.issueHighStressList, month));
        }
        return [];
    });

    /**
     * 10. 性別相談利用人数 [性別利用人数（カウンセリング実施日で算出）]
     */
    // 月データを取得
    const genderData = computed(() => {
        const monthSet = new Set();
        if (monthlyReportStore.genderList.length > 0) {
            monthlyReportStore.genderList.forEach((item) => {
                item.Months.forEach((entry) => {
                    monthSet.add(entry.Month);
                });
            });
        }
        return Array.from(monthSet);
    });

    // テーブルデータの作成
    const tableGenderData = computed(() => {
        const data = { 1: [], 2: [], 3: [], null: [] };
        // genderListが空の場合、初期化された値を返す
        if (monthlyReportStore.genderList.length === 0) return data;

        // 全ての性別に対して初期化
        Object.keys(data).forEach((key) => {
            data[key] = genderData.value.map((month) => ({ month, Volume: '-' }));
        });
        // サーバーからのレスポンスを埋め込む
        monthlyReportStore.genderList.forEach((entry) => {
            if (!entry.Months) return;
            entry.Months.forEach((monthData) => {
                const target = data[entry.GrpGender];
                const monthIndex = genderData.value.indexOf(monthData.Month);
                if (monthIndex !== -1) {
                    target[monthIndex].Volume = monthData.Volume === -1 ? '-' : monthData.Volume;
                }
            });
        });
        return data;
    });

    // [性別利用人数（カウンセリング実施日で算出）] レコードの合計を計算
    const getRowGender = computed(() => {
        if (monthlyReportStore.genderList.length > 0) {
            return Object.keys(tableGenderData.value).reduce((acc, key) => {
                const volumes = tableGenderData.value[key].map((e) => e.Volume);

                // 1つでも '-'が含まれている場合
                if (volumes.includes('-')) {
                    acc[key] = '-';
                } else {
                    // 数値のみの合計
                    acc[key] = tableGenderData.value[key].reduce((sum, v) => sum + (Number(v.Volume) || 0), 0);
                }
                return acc;
            }, {});
        }
        return 0;
    });

    // [性別利用人数（カウンセリング実施日で算出）] カラムの合計を計算
    const getColumnGender = computed(() => {
        if (monthlyReportStore.genderList.length > 0) {
            return genderData.value.map((month, index) => {
                const volumes = Object.values(tableGenderData.value).map((data) => data[index]?.Volume);
                // 1つでも '-'が含まれている場合
                if (volumes.includes('-')) {
                    return '-';
                } else {
                    return volumes.reduce((sum, v) => sum + (Number(v) || 0), 0);
                }
            });
        }
        return 0;
    });

    // [性別利用人数（カウンセリング実施日で算出）] 全体の合計を計算
    const genderTotal = computed(() => {
        if (monthlyReportStore.genderList.length > 0) {
            const volumes = Object.values(getRowGender.value).map((t) => (t === '-' ? '-' : t));
            if (volumes.includes('-')) {
                return '-';
            }

            return volumes.reduce((sum, total) => sum + (Number(total) || 0), 0);
        }
        return 0;
    });

    /**
     * 11. 組織別相談利用人数 [組織別利用人数（カウンセリング実施日で算出）]
     */
    // 月データを取得
    const organizationData = computed(() => {
        const monthSet = new Set();
        if (monthlyReportStore.organizationList.length > 0) {
            monthlyReportStore.organizationList.forEach((item) => {
                item.Months.forEach((entry) => {
                    monthSet.add(entry.Month);
                });
            });
        }
        return Array.from(monthSet);
    });

    const organizationTotal = computed(() => {
        let flag = false;
        if (monthlyReportStore.organizationList.length > 0) {
            return organizationData.value.reduce((sum, month) => {
                const result = getColumnVolume(monthlyReportStore.organizationList, month);
                if (result === '-') {
                    flag = true;
                }
                if (!flag) {
                    return (sum += result);
                } else {
                    return '-';
                }
            }, 0);
        }
        return 0;
    });

    /**
     * 12. 専門機関への紹介件数 [専門機関への紹介件数]
     */
    // 月データを取得
    const referData = computed(() => {
        const monthSet = new Set();
        if (monthlyReportStore.referList.length > 0) {
            monthlyReportStore.referList.forEach((item) => {
                item.Months.forEach((entry) => {
                    monthSet.add(entry.Month);
                });
            });
        }
        return Array.from(monthSet);
    });

    // [専門機関への紹介件数] 全体の合計を取得
    const referTotal = computed(() => {
        if (monthlyReportStore.referList.length > 0) {
            return referData.value.reduce((sum, month) => sum + getColumnAll(monthlyReportStore.referList, month), 0);
        }
        return [];
    });

    // [専門機関への紹介件数] グラフデータ
    const referGraphData = computed(() => {
        if (monthlyReportStore.referList.length > 0) {
            return referData.value.map((month) => getColumnAll(monthlyReportStore.referList, month));
        }
        return [];
    });

    /**
     * 13. 相談満足度 [アンケート満足度]
     */

    // 月データを取得
    const questionData = computed(() => {
        const monthSet = new Set();
        if (monthlyReportStore.questionList.length > 0) {
            monthlyReportStore.questionList.forEach((item) => {
                item.Months.forEach((entry) => {
                    monthSet.add(entry.Month);
                });
            });
        }
        return Array.from(monthSet);
    });

    // リクエスト情報初期化処理
    function reset() {
        monrepcngRequest.resetState();
        monrepcngisuRequest.resetState();
    }

    // 現在の月の前の月を取得して初期値として設定
    function getLastMouth() {
        const now = new Date();
        const currentMonth = now.getMonth() + 1;
        const currentYear = now.getFullYear();

        let lastMonth = currentMonth - 1;
        let lastYear = currentYear;

        if (lastMonth === 0) {
            lastMonth = 12;
            lastYear = currentYear - 1;
        }

        return `${lastYear}/${String(lastMonth).padStart(2, 0)}`;
    }

    // チャートを破棄
    function destroyChart(chartId) {
        if (chartInstances[chartId]) {
            chartInstances[chartId].destroy();
        }
    }
    // ----------------------------
    // ライフサイクル
    // ----------------------------
    onMounted(async () => {
        // セレクトボックスの初期化
        monthlyReportStore.organization = [];
        await commonStore.getDomain();
        // 企業情報取得API
        const response1 = await commonStore.getCompanyAction(commonStore.API_URL);
        if (!response1.success) {
            messageDialog('error', response1.errorMessage);
            if (response1.redirect) {
                location.href = response1.redirectUrl;
            }
            return;
        }
        // 組織選択API
        const response2 = await monthlyReportStore.getOrgSelAction(commonStore.API_URL);
            // 組織が選択できた場合は、初期値として先頭の組織を初期選択に設定する。
            // if (!utils.isNullEmptyArray(monthlyReportStore.organization)) {
            //     organizationPk.value = monthlyReportStore.organization[0].pk;
            // }
       if (!response2.success) {
            messageDialog('error', response2.errorMessage);
            if (response2.redirect) {
                location.href = response2.redirectUrl;
            }
            return;
        }
        // 月次レポート期間取得API
        const response3 = await monthlyReportStore.getMonthlyReportPeriodAction(commonStore.API_URL);
        if (response3.success) {
            monthStart.value = getLastMouth();
            monthEnd.value = getLastMouth();
        } else {
            messageDialog('error', response3.errorMessage);
            if (response3.redirect) {
                location.href = response3.redirectUrl;
            }
            return;
        }
        monthlyReportStore.firstUserList = [];
    });
</script>

<template>
    <section id="main" class="report">
        <div id="contents">
            <section class="reportContentBody">
                <h3 class="textCenter">
                    <span>{{ $t('monthlyReport.parts.pageTitle1') }}</span>
                </h3>
                <ul class="reportFilter">
                    <!-- 企業 -->
                    <li>
                        <dl>
                            <dt>
                                <ul class="filterLabel">
                                    <li>
                                        <label>{{ $t('monthlyReport.parts.dl1') }}</label>
                                    </li>
                                </ul>
                            </dt>
                            <dd style="min-width: 100px">
                                <ul class="filterInput">
                                    <li>
                                        <span>{{ commonStore.companyInfo.CompanyId + ':' + commonStore.companyInfo.CompanyNm }}</span>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </li>
                    <!-- 対象組織 -->
                    <li>
                        <dl>
                            <dt>
                                <ul class="filterLabel">
                                    <li>
                                        <label>{{ $t('monthlyReport.parts.dl2') }}</label>
                                    </li>
                                </ul>
                            </dt>
                            <dd>
                                <ul class="filterInput">
                                    <li>
                                        <div class="select">
                                            <select v-model="organizationPk" required :disabled="disabledControl">
                                                <option value="">{{ $t('common.parts.selectOptionDefault') }}</option>
                                                <option v-for="option in monthlyReportStore.organization" :key="option.id" :value="option.pk">
                                                    {{ option.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </li>
                    <!-- 表示期間 -->
                    <li>
                        <dl>
                            <dt>
                                <ul class="filterLabel">
                                    <li>
                                        <label>{{ $t('monthlyReport.parts.dl3') }}</label>
                                    </li>
                                </ul>
                            </dt>
                            <dd>
                                <ul class="filterInput">
                                    <li>
                                        <div class="select">
                                            <select v-model="monthStart" required :disabled="disabledControl">
                                                <option v-for="option in monthlyReportStore.monthsPeriod" :key="option" :value="option">
                                                    {{ option }}
                                                </option>
                                            </select>
                                        </div>
                                    </li>
                                    <li>
                                        <span>～</span>
                                    </li>
                                    <li>
                                        <div class="select">
                                            <select v-model="monthEnd" required :disabled="disabledControl">
                                                <option v-for="option in monthlyReportStore.monthsPeriod" :key="option" :value="option">
                                                    {{ option }}
                                                </option>
                                            </select>
                                        </div>
                                    </li>
                                </ul>
                            </dd>
                        </dl>
                    </li>
                    <li style="margin-left: auto">
                        <button type="button" class="btnPrimary" style="width: 144px" @click="onDisplay" :disabled="disabledControl">{{ $t('monthlyReport.parts.button1') }}</button>
                    </li>
                </ul>
                <!-- ローディング中は表示 -->
                <div class="reportLoading" v-if="loading">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="#2589d0">
                        <circle cx="12" cy="2" r="2" opacity=".1">
                        <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0"/>
                        </circle>
                        <circle transform="rotate(45 12 12)" cx="12" cy="2" r="2" opacity=".1">
                        <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".125s"/>
                        </circle>
                        <circle transform="rotate(90 12 12)" cx="12" cy="2" r="2" opacity=".1">
                        <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".25s"/>
                        </circle>
                        <circle transform="rotate(135 12 12)" cx="12" cy="2" r="2" opacity=".1">
                        <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".375s"/>
                        </circle>
                        <circle transform="rotate(180 12 12)" cx="12" cy="2" r="2" opacity=".1">
                        <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".5s"/>
                        </circle>
                        <circle transform="rotate(225 12 12)" cx="12" cy="2" r="2" opacity=".1">
                        <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".625s"/>
                        </circle>
                        <circle transform="rotate(270 12 12)" cx="12" cy="2" r="2" opacity=".1">
                        <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".75s"/>
                        </circle>
                        <circle transform="rotate(315 12 12)" cx="12" cy="2" r="2" opacity=".1">
                        <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin=".875s"/>
                        </circle>
                    </svg>
                </div>
                <section class="reportContents" v-if="showContent">
                    <!-- 01. 登録従業員の内訳（性別) [従業員数性別] -->
                    <section class="group">
                        <h5>{{ $t('monthlyReport.parts.title1') }}</h5>
                        <article class="table">
                            <table class="type1" v-if="hasData(monthlyReportStore.userList)">
                                <thead>
                                    <tr>
                                        <th>
                                            <span>{{ $t('monthlyReport.parts.tableHeader1') }}</span>
                                        </th>
                                        <th>
                                            <span>{{ $t('monthlyReport.parts.tableHeader2') }}</span>
                                        </th>
                                        <th>
                                            <span>{{ $t('monthlyReport.parts.tableHeader3') }}</span>
                                        </th>
                                        <th>
                                            <span>{{ $t('monthlyReport.parts.tableHeader4') }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span>{{ formatPercentage('1') }}</span>
                                        </td>
                                        <td>
                                            <span>{{ formatPercentage('2') }}</span>
                                        </td>
                                        <td>
                                            <span>{{ formatPercentage('3') }}</span>
                                        </td>
                                        <td>
                                            <span>{{ formatPercentage('null') }}</span>
                                        </td>
                                        <td class="total">
                                            <span>{{ totalVolume }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                    </section>
                    <!-- 02. 自由登録型従業員利用件数 [自由登録型ユーザー利用件数] -->
                    <section class="group">
                        <h5>
                            {{ $t('monthlyReport.parts.title14') }}
                        </h5>
                        <article class="table">
                            <table class="type2" v-if="hasData(monthlyReportStore.selfSignupList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in selfSignupData" :key="month">
                                            {{ month }}
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th class="title">
                                            <span>{{ $t('monthlyReport.parts.tableHeader7') }}</span>
                                        </th>
                                        <td v-for="month in selfSignupData" :key="month">
                                            <span>{{ getVolAll(month, monthlyReportStore.selfSignupList) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ selfSignupAll }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <article class="graph" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.selfSignupList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph13" style="width: 100%; height: 200px" />
                            </div>
                        </article>
                    </section>
                    <!-- 03. 相談方法別利用件数 [利用件数（相談方法）] -->
                    <section class="group">
                        <h5>
                            {{ $t('monthlyReport.parts.title3') }}
                        </h5>
                        <article class="table">
                            <table class="type2" v-if="hasData(monthlyReportStore.workerList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in workerData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="key in otherKeys" :key="key">
                                        <th :class="'title'">
                                            <span>{{ commonStore.getConvertDictionary('Vol', key) }}</span>
                                        </th>
                                        <td v-for="month in workerData" :key="month">
                                            <span>{{ getOther(month, key) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ workerAll(key) }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                        <td v-for="month in workerData" :key="month">
                                            <span>{{ getMonthlyAll(month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ workerTotal }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <article class="graph" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.workerList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph02" style="width: 100%; height: 200px" />
                            </div>
                        </article>
                    </section>
                    <!-- 04. 相談方法別利用件数（家族） [利用件数/人数（相談方法）（家族）] -->
                    <section class="group">
                        <h5>{{ $t('monthlyReport.parts.title4') }}</h5>
                        <article class="table">
                            <table class="type2" v-if="hasData(monthlyReportStore.familyList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in familyData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="key in otherKeysFamily" :key="key">
                                        <th :class="'title'">
                                            <span>{{ commonStore.getConvertDictionary('Vol', key) }}</span>
                                        </th>
                                        <td v-for="month in familyData" :key="month">
                                            <span>{{ getOtherFamily(month, key) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ familyAll(key) }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                        <td v-for="month in familyData" :key="month">
                                            <span>{{ getMonthlyFamilyAll(month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ familyTotal }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <article class="graph" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.familyList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph03" style="width: 100%; height: 200px" />
                            </div>
                        </article>
                    </section>
                    <!-- 05. 相談内容分類別利用件数 [利用件数（相談内容分類）] -->
                    <section class="group">
                        <h5>{{ $t('monthlyReport.parts.title5') }}</h5>
                        <article class="table">
                            <table class="type2" v-if="hasData(monthlyReportStore.issueClassList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in issueClassData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in monthlyReportStore.issueClassList" :key="item">
                                        <th class="title">
                                            <span v-if="utils.isNullEmpty(item.IssueCatPk) || item.IssueCatPk === '-1'">{{ '不明' }}</span>
                                            <span v-else>{{ utils.isNull(item.IssueCatNm) ? '' : item.IssueCatNm }}</span>
                                        </th>
                                        <td v-for="month in issueClassData" :key="month">
                                            <span>{{ getMonthlyVol(item, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ getRowAll(item) }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                        <td v-for="month in issueClassData" :key="month">
                                            <span>{{ getColumnAll(monthlyReportStore.issueClassList, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ issueClassTotal }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <article class="graph marginBottom30" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.issueClassList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph04" style="width: 100%; height: 200px" />
                            </div>
                        </article>
                    </section>
                    <!-- 06. 相談内容別利用件数 [利用件数（相談内容）] -->
                    <section class="group">
                        <h5>{{ $t('monthlyReport.parts.title6') }}</h5>
                        <article class="table">
                            <table class="type2" v-if="hasData(monthlyReportStore.issueList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in issueData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in monthlyReportStore.issueList" :key="item">
                                        <th class="title">
                                            <span v-if="utils.isNullEmpty(item.IssuePk) || item.IssuePk === '-1'">{{ '不明' }}</span>
                                            <span v-else>{{ utils.isNull(item.IssueNm) ? '' : item.IssueNm }}</span>
                                        </th>
                                        <td v-for="month in issueData" :key="month">
                                            <span>{{ getMonthlyVol(item, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ getRowAll(item) }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                        <td v-for="month in issueData" :key="month">
                                            <span>{{ getColumnAll(monthlyReportStore.issueList, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ issueTotal }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <article class="graph" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.issueList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph05" style="width: 100%; height: 200px" />
                            </div>
                        </article>
                    </section>
                    <!-- 07. 現況把握内容別回答人数 [現況把握内容別回答人数] -->
                    <section class="group" v-if="!organizationPk">
                        <h5>{{ $t('monthlyReport.parts.title11') }}</h5>
                        <article class="table marginBottom15">
                            <table class="type2" v-if="hasData(monthlyReportStore.understandList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in understandData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in monthlyReportStore.understandList" :key="item">
                                        <th class="title">
                                            <span>{{ commonStore.getConvertDictionary('CurrentStatus', item.CurrentStatus) }}</span>
                                        </th>
                                        <td v-for="month in understandData" :key="month">
                                            <span>{{ getMonthlyVol(item, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ getRowAll(item) }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                        <td v-for="month in understandData" :key="month">
                                            <span>{{ getColumnAll(monthlyReportStore.understandList, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ understandTotal }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <article class="graph marginBottom30" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.understandList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph10" style="width: 100%; height: 200px" />
                            </div>
                        </article>
                    </section>
                    <!-- 08. 高ストレス者・要注意者利用件数 [高ストレス者利用件数] -->
                    <section class="group">
                        <h5>
                            {{ $t('monthlyReport.parts.title12') }}
                        </h5>
                        <article class="table marginBottom15">
                            <table class="type2" v-if="hasData(monthlyReportStore.highStressList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in highStressData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th class="title">
                                            <span>{{ $t('monthlyReport.parts.tableHeader8') }}</span>
                                        </th>
                                        <td v-for="month in highStressData" :key="month">
                                            <span>{{ getVolAll(month, monthlyReportStore.highStressList) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ highStressAll }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <article class="graph marginBottom30" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.highStressList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph11" style="width: 100%; height: 200px" />
                            </div>
                        </article>
                    </section>
                    <!-- 09. 高ストレス者ｘ相談内容別利用件数 [高ストレス者利用件数（相談内容）] -->
                    <section class="group">
                        <h5>
                            {{ $t('monthlyReport.parts.title13') }}
                        </h5>
                        <article class="table marginBottom15">
                            <table class="type2" v-if="hasData(monthlyReportStore.issueHighStressList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in issueHighStressData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in monthlyReportStore.issueHighStressList" :key="item">
                                        <th class="title">
                                            <span v-if="utils.isNullEmpty(item.IssuePk) || item.IssuePk === '-1'">{{ '不明' }}</span>
                                            <span v-else>{{ utils.isNull(item.IssueNm) ? '' : item.IssueNm }}</span>
                                        </th>
                                        <td v-for="month in issueHighStressData" :key="month">
                                            <span>{{ getMonthlyVol(item, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ getRowVolume(item) }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                        <td v-for="month in issueHighStressData" :key="month">
                                            <span>{{ getColumnAll(monthlyReportStore.issueHighStressList, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ issueHighStressTotal }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <article class="graph marginBottom30" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.issueHighStressList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph12" style="width: 100%; height: 200px" />
                            </div>
                        </article>
                    </section>
                    <!-- 10. 性別相談利用人数 [性別利用人数（カウンセリング実施日で算出）] -->
                    <section class="group">
                        <h5>{{ $t('monthlyReport.parts.title9') }}</h5>
                        <article class="table marginBottom15">
                            <table class="type2" v-if="hasData(monthlyReportStore.genderList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in genderData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(items, key) in tableGenderData" :key="key">
                                        <th class="title">
                                            <span>{{ commonStore.getConvertDictionary('GrpGender', key) }}</span>
                                        </th>
                                        <td v-for="item in items" :key="item.month">
                                            <span>{{ item.Volume }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ getRowGender[key] }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                        <td v-for="(total, index) in getColumnGender" :key="index">
                                            <span>{{ total }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ genderTotal }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <!-- <article class="graph marginBottom30" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.genderList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph08" style="width: 100%; height: 200px" />
                            </div>
                        </article> -->
                    </section>
                    <!-- 11. 組織別相談利用人数 [組織別利用人数（カウンセリング実施日で算出）] -->
                    <section class="group">
                        <h5>{{ $t('monthlyReport.parts.title16') }}</h5>
                        <article class="table marginBottom15">
                            <table class="type2" v-if="hasData(monthlyReportStore.organizationList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in organizationData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in monthlyReportStore.organizationList" :key="item.GrpOrganizationPk">
                                        <th class="title">
                                            <span v-if="utils.isNullEmpty(item.GrpOrganizationPk) || item.GrpOrganizationPk === '-1'">{{ '不明' }}</span>
                                            <span v-else>{{ utils.isNull(item.GrpOrganizationNmP) ? '' : item.GrpOrganizationNmP }}</span>
                                        </th>
                                        <td v-for="month in organizationData" :key="month">
                                            <span>{{ getMonthlyVolume(item, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ getRowVolume(item) }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                        <td v-for="month in organizationData" :key="month">
                                            <span>{{ getColumnVolume(monthlyReportStore.organizationList, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ organizationTotal }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <!-- <article class="graph marginBottom30" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.organizationList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph14" style="width: 100%; height: 200px" />
                            </div>
                        </article> -->
                    </section>
                    <!-- 12. 専門機関への紹介件数 [専門機関への紹介件数] -->
                    <section class="group">
                        <h5>{{ $t('monthlyReport.parts.title8') }}</h5>
                        <article class="table marginBottom15">
                            <table class="type2" v-if="hasData(monthlyReportStore.referList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in referData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in monthlyReportStore.referList" :key="item.ReferDestCd">
                                        <th class="title">
                                            <span v-if="utils.isNullEmpty(item.ReferDestCd) || item.ReferDestCd === '-1'">{{ '不明' }}</span>
                                            <span v-else>{{ utils.isNull(item.ReferDestNm) ? '' : item.ReferDestNm }}</span>
                                        </th>
                                        <td v-for="month in referData" :key="month">
                                            <span>{{ getMonthlyVol(item, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ getRowAll(item) }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                        <td v-for="month in referData" :key="month">
                                            <span>{{ getColumnAll(monthlyReportStore.referList, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ referTotal }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                        <article class="graph marginBottom30" style="width: 100%; height: 200px; display: flex" v-if="hasData(monthlyReportStore.referList)">
                            <span style="font-size: 12px; margin-right: 10px">{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                            <div style="width: 1586px; position: relative; display: block">
                                <canvas id="graph07" style="width: 100%; height: 200px" />
                            </div>
                        </article>
                    </section>
                    <!-- 13. 相談満足度 [アンケート満足度] -->
                    <section class="group">
                        <h5>{{ $t('monthlyReport.parts.title15') }}</h5>
                        <article class="table marginBottom15">
                            <table class="type2" v-if="hasData(monthlyReportStore.questionList)">
                                <thead>
                                    <tr>
                                        <th class="title" />
                                        <th v-for="month in questionData" :key="month">
                                            <span>{{ month }}</span>
                                        </th>
                                        <th class="total">
                                            <span>{{ $t('monthlyReport.parts.tableHeader5') }}</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in monthlyReportStore.questionList" :key="item.ReferDestCd">
                                        <th class="title">
                                            <span>{{ utils.isNull(item.AnswerType) ? '不明' : item.AnswerType }}</span>
                                        </th>
                                        <td v-for="month in questionData" :key="month">
                                            <span>{{ getMonthlyVol(item, month) }}</span>
                                        </td>
                                        <th class="total">
                                            <span>{{ getRowAll(item) }}</span>
                                        </th>
                                    </tr>
                                </tbody>
                            </table>
                        </article>
                    </section>
                </section>
            </section>
        </div>
    </section>
</template>

<style scoped>
    .select::after {
        content: '';
        width: 26px;
        height: 26px;
        background-position: center 5px;
    }
    .report #contents {
        display: flex;
    }
</style>
